@if (isEmbedded()) {
  <ocp-embedded-layout>
    <router-outlet />
  </ocp-embedded-layout>
} @else {
  <ocp-main-layout
    [userInitials]="userInitials()"
    [userName]="userName()"
    [userEmail]="userEmail()"
  >
    <router-outlet />
  </ocp-main-layout>
}
